// extracted by mini-css-extract-plugin
module.exports = {"container":"InvestorEvents_container__3Lcu6","title":"InvestorEvents_title__1anAS","content":"InvestorEvents_content__3FFI2"};